module.exports = __webpack_public_path__ + "media/src/assets/images/logo-9eaffb9733cd9469ee03d045800e191e.svg";